module.exports = __webpack_public_path__ + "static/media/devices.d247effa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-4/devices.png
// module id = 724
// module chunks = 0